
  <mat-toolbar color='primary' class='navbar'>
    <div>Weather Application</div>
    <div>
      <span>About</span>
      <span>FeedBack</span>
      <span>Services</span>
    </div>
  </mat-toolbar>
<div class='container-fluid'>
  <app-city-select *ngIf='display' (displayValue)='display=$event.value'></app-city-select>
  <router-outlet></router-outlet>
</div>
<!-- <div class='container'> -->
<!-- </div> -->